/**
 * Filters and array of objects by keyword from multiple properties
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "keyWord",
    standalone: false
})
export class KeywordPipe implements PipeTransform {
  transform<T>(value: T[], properties?: any[], keyword?: string, split: boolean = false, useOrLogic: boolean = false): T[] {
    // don't filter unless a keyword or list is provided
    if (!keyword) return value;
    if (!value || value.length < 1) return [];

    // if specified, split the keyword and check that ALL parts match something
    const keywords = split ? keyword.trim().split(/\s/) : [keyword];

    if (useOrLogic) {
      return value.filter(v => keywords.some(kw => properties.some(p => v[p] && v[p].toString().toLowerCase().indexOf(kw.toLowerCase()) !== -1)));
    }
    else {
      return value.filter(v => keywords.every(kw => properties.some(p => v[p] && v[p].toString().toLowerCase().indexOf(kw.toLowerCase()) !== -1)));
    }
  }
}
